/**
 * @date: 2022-04-18
 * @author: Kevin Hsiau <khsiau@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 */

import React, {useEffect, useState} from "react";
import {Button, Fade, Menu, MenuItem} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import {StyledQueryDiv, StyledSearchDiv} from "../Contributions/ContributionSearchPanel";
import {getQueryString} from "../utils/http-helpers";


export default function AdHocReportSearchPanel (props) {

    const {
        onQueryStringChanged,
        onRefresh,
        setPage,
        info,
        type,
    } = props;

    const [params, setParams] = useState({});
    const [queryString, setQueryString] = useState("");

    const [hispAnchorEl, setHispAnchorEl] = useState(null);
    const [hispName, setHispName] = useState("SELECT A HISP")
    const hispOpen = Boolean(hispAnchorEl);

    const [fieldNameAnchorEl, setFieldNameAnchorEl] = useState(null);
    const [fieldName, setFieldName] = useState("Select a Field Name");
    const fieldNameOpen = Boolean(fieldNameAnchorEl);

    const [ruleNameAnchorEl, setRuleNameAnchorEl] = useState(null);
    const [ruleName, setRuleName] = useState("Select a Rule Name");
    const ruleNameOpen = Boolean(ruleNameAnchorEl);

    useEffect(() => {
        console.log("useEffect, query String updated: ", queryString);
        onQueryStringChanged(queryString);
    }, [queryString])


    const handleHispClose = (event) => {
        const value = event.target.id;
        const newParams = {...params};
        if (value === "" || value === "close") {
            setHispName("SELECT A HISP");
            if (newParams.hispId !== undefined) {
                delete newParams.hispId;
            }
        } else {
            setHispName(value);
            newParams.hispId = value;
        }
        setParams(newParams);
        setHispAnchorEl(null);
    };

    const handleFieldNameClose = (event) => {
        const value = event.target.id;
        const newParams = {...params};
        if (value === "" || value === "close") {
            setFieldName("Select a Field Name");
            if (newParams.fieldName !== undefined) {
                delete newParams.fieldName;
            }
        } else {
            setFieldName(value);
            newParams.fieldName = value;
        }
        setParams(newParams);
        setFieldNameAnchorEl(null);
    };

    const handleRuleNameClose = (event) => {
        const value = event.target.id;
        const newParams = {...params};
        if (value === "" || value === "close") {
            setRuleName("Select a Rule Name");
            if (newParams.ruleName !== undefined) {
                delete newParams.ruleName;
            }
        } else {
            setRuleName(value);
            newParams.ruleName = value;
        }
        setParams(newParams);
        setRuleNameAnchorEl(null);
    };

    const handleSearch = () => {
        setPage(0);
        const s = getQueryString(params);
        console.log("search ", params, s);
        setQueryString(s);
    }

    const handleResetClick = () => {
        setPage(0);
        setParams({});
        setQueryString(getQueryString({}));
        setHispName("SELECT A HISP");
        setFieldName("Select a Field Name");
        setRuleName("Select a Rule Name");
    }

    const handleRefresh = () => {
        onRefresh(new Date().getTime());
    }

    return (
        <div>
            <StyledQueryDiv>
                {type === 'publish' &&
                    <>
                        <Button
                            id="hisps-button"
                            aria-controls={hispOpen ? 'hisps-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={hispOpen ? 'true' : undefined}
                            onClick={(event) => setHispAnchorEl(event.currentTarget)}
                            variant="text"
                            endIcon={<KeyboardArrowDownIcon/>}
                        >
                            {hispName}
                        </Button>
                        <Menu
                            id="hisps-menu"
                            anchorEl={hispAnchorEl}
                            open={hispOpen}
                            onClose={handleHispClose}
                            MenuListProps={{
                                'aria-labelledby': 'hisps-button',
                            }}
                            TransitionComponent={Fade}
                        >
                            <MenuItem id='close' onClick={handleHispClose}>Select A Hisp</MenuItem>
                            {info?.detailsInfo?.publishedHISPs &&
                                Object.entries(info.detailsInfo.publishedHISPs).map(([key, value]) => (
                                    <MenuItem id={key} key={key} onClick={handleHispClose}>{key}</MenuItem>
                                ))}
                        </Menu>
                    </>
                }

                <Button
                    id="fieldName-button"
                    aria-controls={fieldNameOpen ? 'fieldName-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={fieldNameOpen ? 'true' : undefined}
                    onClick={(event) => setFieldNameAnchorEl(event.currentTarget)}
                    variant="text"
                    endIcon={<KeyboardArrowDownIcon/>}
                >
                    {fieldName}
                </Button>
                <Menu
                    id="fieldName-menu"
                    anchorEl={fieldNameAnchorEl}
                    open={fieldNameOpen}
                    onClose={handleFieldNameClose}
                    TransitionComponent={Fade}
                    MenuListProps={{
                        'aria-labelledby': 'fieldName-button',
                    }}
                >
                    <MenuItem id='close' onClick={handleFieldNameClose}>Select A Field Name</MenuItem>
                    {info?.binaryFieldNames?.length > 0 &&
                        info.binaryFieldNames.map( (b, index ) => (
                            <MenuItem id={b} key={index} onClick={handleFieldNameClose}>{b}</MenuItem>
                        ))
                    }
                </Menu>


                <Button
                    id="ruleName-button"
                    aria-controls={ruleNameOpen ? 'ruleName-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={ruleNameOpen ? 'true' : undefined}
                    onClick={(event) => setRuleNameAnchorEl(event.currentTarget)}
                    variant="text"
                    endIcon={<KeyboardArrowDownIcon/>}
                >
                    {ruleName}
                </Button>
                <Menu
                    id="ruleName-menu"
                    anchorEl={ruleNameAnchorEl}
                    open={ruleNameOpen}
                    onClose={handleRuleNameClose}
                    TransitionComponent={Fade}
                    MenuListProps={{
                        'aria-labelledby': 'ruleName-button',
                    }}
                >
                    <MenuItem id='close' onClick={handleRuleNameClose}>Select A Rule Name</MenuItem>
                    {info?.binaryRuleNames?.length > 0 &&
                        info.binaryRuleNames.map((b, index) => (
                            <MenuItem id={b} key={index} onClick={handleRuleNameClose}>{b}</MenuItem>
                        ))
                    }
                </Menu>
            </StyledQueryDiv>

            <StyledSearchDiv>
                <Button variant='contained' onClick={handleSearch} startIcon={<SearchIcon/>}>
                    Search
                </Button>
                <Button variant='outlined' onClick={handleRefresh} startIcon={<RefreshIcon />}>
                    Refresh
                </Button>
                <Button variant='outlined' onClick={handleResetClick}>
                    Reset
                </Button>
            </StyledSearchDiv>
        </div>
    );
}